import { Dtos, IndemnityAgreementSignatureMethod } from "@inrev/common";
import { Text } from "@portal/components/primitives";
import { FC } from "react";
import { AdminDataList } from "../../../../shared/admin/AdminDataList";

export type AdminAccountIndemnitorSignatureStatusListProps = {
	indemnityAgreement: Dtos.SuretyAccount.IndemnityAgreement.Get.Response;
};

const IndemnitorRow = ({
	name,
	signerEmail,
	completed,
	showSignatureStatus,
	incompleteWhenUndefined = false,
}: {
	name: string;
	signerEmail?: string | null;
	completed?: boolean;
	showSignatureStatus: boolean;
	incompleteWhenUndefined?: boolean;
}) => {
	const showIncomplete =
		showSignatureStatus &&
		(completed === false || (incompleteWhenUndefined && completed === undefined));
	const showComplete = showSignatureStatus && completed === true;

	return (
		<div className="flex justify-between items-center flex-1 space-x-[10px] py-0.5">
			<Text type="body" color="secondary" className="text-left [text-box-trim:none]">
				{name}
			</Text>
			{signerEmail && (
				<>
					<div className="w-[1px] h-[18px] bg-bc-default" />
					<Text type="body-strong" color="tertiary" className="text-right [text-box-trim:none]">
						{signerEmail}
					</Text>
				</>
			)}
			{showSignatureStatus && (showIncomplete || showComplete) && (
				<>
					<div className="w-[1px] h-[18px] bg-bc-default" />
					{showComplete ? (
						<Text type="body-strong" color="confirm" className="[text-box-trim:none]">
							Signed
						</Text>
					) : (
						<Text type="body" color="tertiary" className="italic [text-box-trim:none]">
							Hasn't signed
						</Text>
					)}
				</>
			)}
		</div>
	);
};

export const AdminAccountIndemnitorSignatureStatusList: FC<
	AdminAccountIndemnitorSignatureStatusListProps
> = ({ indemnityAgreement }) => {
	const showSignatureStatus =
		indemnityAgreement.signatureMethod === IndemnityAgreementSignatureMethod.electronic;

	return (
		<AdminDataList
			data={[
				{
					label: "Status",
					value: indemnityAgreement.status,
				},
				{
					label: "Signature Method",
					value: indemnityAgreement.signatureMethod,
				},
				{
					label: "Indemnitors",
					value: (
						<div className="w-fit flex flex-col gap-y-3">
							{indemnityAgreement.indemnitors.companies.map((indemnitor, index) => (
								<IndemnitorRow
									key={index}
									name={indemnitor.name}
									signerEmail={indemnitor.signerEmail}
									completed={indemnitor.completed}
									showSignatureStatus={showSignatureStatus}
								/>
							))}
							{indemnityAgreement.indemnitors.individuals.map((indemnitor, index) => (
								<IndemnitorRow
									key={index}
									name={indemnitor.name}
									signerEmail={indemnitor.signerEmail}
									completed={indemnitor.completed}
									showSignatureStatus={showSignatureStatus}
									incompleteWhenUndefined
								/>
							))}
						</div>
					),
				},
			]}
		/>
	);
};
